import React, { useState } from "react";
import * as Yup from "yup";
import { CircularProgress } from "@mui/material";
import Moment from "moment";
import { ErrorMessage, Form, Formik } from "formik";
import { Field } from "formik";
import TextError from "../../../Components/HealthInsFormikComponent/TextError";
import DobCKYC from "../../CareHealthKYC/CKYC/DobCKYC";
import Axios from "axios";
import Swal from "sweetalert2";
// import dayjs from 'dayjs';

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import axiosInstance from "../../../Utilities/djangoAxiosInstance";

function FormPrimaryGenRef(props) {
  const { setParentNext, ckycId, decryptedResponseId, a_id } = props;
  const [submitForm, setSubmitForm] = useState(false);
  const initialValues = {
    ckycId: "",
    genderId: "",
    birthdate: "",
    occupationId: "",
    incomeSourceId: "",
    isAnyonePEP: "",
    PEPremarks: "",
  };

  // const [value, setValue] = React.useState(dayjs());
  const [value, setValue] = useState("");

  // const handleChange = (Value) => {

  //   console.log("New ",Value)
  // };

  const onSubmit = (data) => {
    setSubmitForm(true);
    console.log("submit values", data);
    let dob =
      data.birthdate === ""
        ? ""
        : Moment(data.birthdate).format("MMMM DD, yyyy");
    console.log("newDate", dob);
    let newckycID = Number(ckycId);
    console.log("ckycid", newckycID);
    let starBodyJson = {
      ckycId: newckycID,
      genderId: data.genderId,
      birthdate: dob,
      occupationId: data.occupationId,
      incomeSourceId: data.incomeSourceId,
      isAnyonePEP: data.isAnyonePEP,
    };
    if (data.isAnyonePEP === "1") {
      starBodyJson = { ...starBodyJson, pepRemarks: data.PEPremarks };
    }
    console.log("StarBodyJson1", JSON.stringify(starBodyJson));

    var formData = new FormData();
    formData.append("bodyJson", JSON.stringify(starBodyJson));
    let domain = "";
     

    axiosInstance.post(
      `api/health-insurance/starhealth/generate-ckyc-referenceid/${decryptedResponseId}/${a_id}/`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        }
      }
    )
      .then((response) => {
        console.log("Response from server: ", response);
        if (response.status === 200) {
          console.log("Success");
          Swal.fire({
            icon: "success",
            title: `Your Reference Id is generated\n REF-ID: ${response.data.ckycReferenceId}`,
            text: "Click on OK button to proceed",
            position: "center",

            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            if (result.isConfirmed) {
              setParentNext(false);
              setSubmitForm(false);
            }
          });
        }
      })
      .catch((error) => {
        if (error.response.status !== 200) {
          let errMSG = "";
          if (Array.isArray(error.response.data.message)) {
            errMSG = error.response.data.message[0].errDescription;
          } else {
            errMSG = error.response.data.message;
          }
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: `${errMSG}`,
            position: "center",
            // showConfirmButton: true,
            // confirmButtonText: "Continue",
            showCancelButton: true,
            cancelButtonText: "Re-Enter Document Details",
            showClass: {
              popup: "animate__animated animate__fadeInDown",
            },
            hideClass: {
              popup: "animate__animated animate__fadeOutUp",
            },
          }).then((result) => {
            // if (result.isConfirmed) {

            //   setSubmitForm(false);
            // } else
            if (result.dismiss === "cancel") {
              setSubmitForm(false);
              setParentNext(true);
            }
            console.log(result, "ff");
          });
          setSubmitForm(false);
          setParentNext(true);
        }
        console.log(error);
      });
  };

  const validationSchema = Yup.object().shape({
    genderId: Yup.string().required("Gender Field is Required"),

    birthdate: Yup.string().required("D.O.B Field is Required"),

    occupationId: Yup.string().required("Occupation Field is Required"),

    incomeSourceId: Yup.string().required("IncomeSource Field is Required"),

    isAnyonePEP: Yup.string().required("This Field is Required"),

    PEPremarks: Yup.mixed().when("isAnyonePEP", {
      is: "1",
      then: Yup.string()
        .required("PEP remarks is Required")
        .max(50, "Cannot be more than 50 characters"),
    }),
  });

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {(formik) => (
          <Form>
            {console.log(formik)}
            <div
              className="form-container"
              component={TextError}
              style={{ marginBottom: "48px" }}
            >
              <div className="d-flex justify-content-center">
                <h3>Generate Reference ID</h3>
              </div>

              <div className="form-group mb-4 ">
                <label htmlFor="genderId fw-bold">Gender</label>
                <Field
                  className={
                    formik.touched.genderId && formik.errors.genderId
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.genderId && formik.touched.genderId
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                  as="select"
                  name="genderId"
                  id="genderId"
                >
                  <option value="">Select</option>
                  <option value="1">Male</option>
                  <option value="2">Female</option>
                  <option value="3">Transgender</option>
                </Field>
                <ErrorMessage name="genderId" component={TextError} />
              </div>

              <div className="form-group mb-3 " style={{ paddingTop: "20px" }}>
                <label
                  htmlFor="star_adhaar_dob"
                  className="fw-light"
                  style={{ paddingBottom: "8px" }}
                >
                  Date of Birth as per Govt. Document
                </label>
                <div className="input-icons">
                  <Field
                    type="text"
                    name="birthdate"
                    id="birthdate"
                    className={
                      formik.touched.birthdate && formik.errors.birthdate
                        ? " errorStyle form-control bg-white"
                        : !formik.errors.birthdate && formik.touched.birthdate
                        ? " successField form-control bg-white"
                        : " form-control bg-white"
                    }
                    component={DobCKYC}
                  />
                </div>
                <ErrorMessage name="birthdate" component={TextError} />
              </div>

              {/* <div className="form-group mb-4 ">
                <label htmlFor="birthdate fw-bold">Birthdate</label>
                <Field
                  className={
                    formik.touched.birthdate && formik.errors.birthdate
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.birthdate && formik.touched.birthdate
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                  name="birthdate"
                  id="birthdate"
                  type="date"
                ></Field>
                <ErrorMessage name="birthdate" component={TextError} />
              </div> */}

              <div className="form-group mb-4 ">
                <label htmlFor="occupationId fw-bold">Occupation</label>
                <Field
                  className={
                    formik.touched.occupationId && formik.errors.occupationId
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.occupationId &&
                        formik.touched.occupationId
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                  as="select"
                  name="occupationId"
                >
                  <option value="">Select</option>
                  <option value="1">Professional</option>
                  <option value="2">Self Employed</option>
                  <option value="3">Retired</option>
                  <option value="4">House-wife</option>
                  <option value="5">Student</option>
                </Field>
                <ErrorMessage name="occupationId" component={TextError} />
              </div>

              <div className="form-group mb-4 ">
                <label htmlFor="incomeSourceId fw-bold">IncomeSource</label>
                <Field
                  className={
                    formik.touched.incomeSourceId &&
                    formik.errors.incomeSourceId
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.incomeSourceId &&
                        formik.touched.incomeSourceId
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                  as="select"
                  name="incomeSourceId"
                >
                  <option value="">Select</option>
                  <option value="1">Salary</option>
                  <option value="2">Business Income</option>
                  <option value="3">Sale of Assets</option>
                  <option value="4">Inheritance</option>
                </Field>
                <ErrorMessage name="incomeSourceId" component={TextError} />
              </div>

              <div className="form-group mb-4 ">
                <label htmlFor="isAnyonePEP fw-bold">Is Anyone PEP</label>
                <Field
                  className={
                    formik.touched.isAnyonePEP && formik.errors.isAnyonePEP
                      ? "errorStyle form-control bg-white"
                      : !formik.errors.isAnyonePEP && formik.touched.isAnyonePEP
                      ? "successField form-control bg-white"
                      : "form-control bg-white"
                  }
                  as="select"
                  name="isAnyonePEP"
                >
                  <option value="">Select</option>
                  <option value="0">No</option>
                  <option value="1">Yes</option>
                </Field>
                <ErrorMessage name="isAnyonePEP" component={TextError} />
              </div>

              {formik.values["isAnyonePEP"] === "1" ? (
                <div className="form-group mb-4 ">
                  <label htmlFor="isAnyonePEP fw-bold">PEP remarks</label>
                  <Field
                    type="text"
                    name="PEPremarks"
                    id="PEPremarks"
                    className={
                      formik.touched.PEPremarks && formik.errors.PEPremarks
                        ? " errorStyle form-control bg-white"
                        : !formik.errors.PEPremarks && formik.touched.PEPremarks
                        ? " successField form-control bg-white"
                        : " form-control bg-white"
                    }
                  />
                  <ErrorMessage name="PEPremarks" component={TextError} />
                </div>
              ) : null}
              {/* <button
                className="submitBtn text-capatilize mr-8"
                type="submit"
                onSubmit={onSubmit}
              >
                Submit
              </button> */}

              <div className="mt-3">
                {!submitForm ? (
                  <button
                    className="submitBtn text-capitalize "
                    type="submit"
                    //disabled={formik.isSubmitting}
                  >
                    Submit
                  </button>
                ) : (
                  <div className="d-flex justify-content-center">
                    <CircularProgress
                      size={48}
                      sx={{
                        color: "red",
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}

export default FormPrimaryGenRef;
